// LoginPage
export const RESET_LOGIN_META = 'RESET_LOGIN_META';
export const RESET_LOGIN_PAGE = 'RESET_LOGIN_PAGE';

export const LOGIN_REQUEST_OTP_REQUEST = 'LOGIN_REQUEST_OTP_REQUEST';
export const LOGIN_REQUEST_OTP_SUCCESS = 'LOGIN_REQUEST_OTP_SUCCESS';
export const LOGIN_REQUEST_OTP_ERROR = 'LOGIN_REQUEST_OTP_ERROR';

export const LOGIN_VERIFY_OTP_REQUEST = 'LOGIN_VERIFY_OTP_REQUEST';
export const LOGIN_VERIFY_OTP_SUCCESS = 'LOGIN_VERIFY_OTP_SUCCESS';
export const LOGIN_VERIFY_OTP_ERROR = 'LOGIN_VERIFY_OTP_ERROR';

export const GET_PUBLISHED_EVENT_REQUEST = 'GET_PUBLISHED_EVENT_REQUEST';
export const GET_PUBLISHED_EVENT_ERROR = 'GET_PUBLISHED_EVENT_ERROR';
export const GET_PUBLISHED_EVENT_SUCCESS = 'GET_PUBLISHED_EVENT_SUCCESS';

// SignUp Page
export const RESET_SIGNUP_META = 'RESET_SIGNUP_META';
export const RESET_SIGNUP_PAGE = 'RESET_SIGNUP_PAGE';

export const SIGNUP_REQUEST_OTP_REQUEST = 'SIGNUP_REQUEST_OTP_REQUEST';
export const SIGNUP_REQUEST_OTP_SUCCESS = 'SIGNUP_REQUEST_OTP_SUCCESS';
export const SIGNUP_REQUEST_OTP_ERROR = 'SIGNUP_REQUEST_OTP_ERROR';

export const SIGNUP_VERIFY_OTP_REQUEST = 'SIGNUP_VERIFY_OTP_REQUEST';
export const SIGNUP_VERIFY_OTP_SUCCESS = 'SIGNUP_VERIFY_OTP_SUCCESS';
export const SIGNUP_VERIFY_OTP_ERROR = 'SIGNUP_VERIFY_OTP_ERROR';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';

//Application Information Page
export const GET_APPLICATION_INFO_REQUEST = 'GET_APPLICATION_INFO_REQUEST';
export const GET_APPLICATION_INFO_ERROR = 'GET_APPLICATION_INFO_ERROR';
export const GET_APPLICATION_INFO_SUCCESS = 'GET_APPLICATION_INFO_SUCCESS';

export const SUBMIT_APPLICATION_INFO_REQUEST = 'SUBMIT_APPLICATION_INFO_REQUEST';
export const SUBMIT_APPLICATION_INFO_ERROR = 'SUBMIT_APPLICATION_INFO_ERROR';
export const SUBMIT_APPLICATION_INFO_SUCCESS = 'SUBMIT_APPLICATION_INFO_SUCCESS';

export const RESET_APPLICATION_INFO_PAGE = 'RESET_APPLICATION_INFO_PAGE';
export const RESET_APPLICATION_INFO_META = 'RESET_APPLICATION_INFO_META';

//Referee Information Page
export const GET_REFEREE_INFO_REQUEST = 'GET_REFEREE_INFO_REQUEST';
export const GET_REFEREE_INFO_ERROR = 'GET_REFEREE_INFO_ERROR';
export const GET_REFEREE_INFO_SUCCESS = 'GET_REFEREE_INFO_SUCCESS';

export const SUBMIT_REFEREE_INFO_REQUEST = 'SUBMIT_REFEREE_INFO_REQUEST';
export const SUBMIT_REFEREE_INFO_ERROR = 'SUBMIT_REFEREE_INFO_ERROR';
export const SUBMIT_REFEREE_INFO_SUCCESS = 'SUBMIT_REFEREE_INFO_SUCCESS';

export const RESET_REFEREE_INFO_PAGE = 'RESET_REFEREE_INFO_PAGE';
export const RESET_REFEREE_INFO_META = 'RESET_REFEREE_INFO_META';

//Document Page
export const GET_DOCUMENT_REQUEST = 'GET_DOCUMENT_REQUEST';
export const GET_DOCUMENT_ERROR = 'GET_DOCUMENT_ERROR';
export const GET_DOCUMENT_SUCCESS = 'GET_DOCUMENT_SUCCESS';

export const SUBMIT_DOCUMENT_REQUEST = 'SUBMIT_DOCUMENT_REQUEST';
export const SUBMIT_DOCUMENT_ERROR = 'SUBMIT_DOCUMENT_ERROR';
export const SUBMIT_DOCUMENT_SUCCESS = 'SUBMIT_DOCUMENT_SUCCESS';

export const RESET_DOCUMENT_PAGE = 'RESET_DOCUMENT_PAGE';
export const RESET_DOCUMENT_META = 'RESET_DOCUMENT_META';

//  Important Notes Page
export const GET_EVENT_REQUEST = 'GET_EVENT_REQUEST';
export const GET_EVENT_ERROR = 'GET_EVENT_ERROR';
export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS';

export const SUBMIT_START_APPLICATION_REQUEST = 'SUBMIT_START_APPLICATION_REQUEST';
export const SUBMIT_START_APPLICATION_ERROR = 'SUBMIT_START_APPLICATION_ERROR';
export const SUBMIT_START_APPLICATION_SUCCESS = 'SUBMIT_START_APPLICATION_SUCCESS';

export const RESET_START_APPLICATION_PAGE = 'RESET_APPLICATION_INFO_PAGE';
export const RESET_START_APPLICATION_META = 'RESET_START_APPLICATION_META';

// Personal Particulars Page
export const GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_REQUEST = 'GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_REQUEST';
export const GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_ERROR = 'GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_ERROR';
export const GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_SUCCESS = 'GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_SUCCESS';

export const SUBMIT_PERSONAL_PARTICULAR_REQUEST = 'SUBMIT_PERSONAL_PARTICULAR_REQUEST';
export const SUBMIT_PERSONAL_PARTICULAR_ERROR = 'SUBMIT_PERSONAL_PARTICULAR_ERROR';
export const SUBMIT_PERSONAL_PARTICULAR_SUCCESS = 'SUBMIT_PERSONAL_PARTICULAR_SUCCESS';

export const RESET_PERSONAL_PARTICULAR_PAGE = 'RESET_PERSONAL_PARTICULAR_PAGE';
export const RESET_PERSONAL_PARTICULAR_META = 'RESET_PERSONAL_PARTICULAR_META';

//  Education Background Page
export const GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_REQUEST = 'GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_REQUEST';
export const GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_ERROR = 'GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_ERROR';
export const GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_SUCCESS = 'GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_SUCCESS';

export const SUBMIT_EDUCATION_BACKGROUND_REQUEST = 'SUBMIT_EDUCATION_BACKGROUND_REQUEST';
export const SUBMIT_EDUCATION_BACKGROUND_ERROR = 'SUBMIT_EDUCATION_BACKGROUND_ERROR';
export const SUBMIT_EDUCATION_BACKGROUND_SUCCESS = 'SUBMIT_EDUCATION_BACKGROUND_SUCCESS';

export const RESET_EDUCATION_BACKGROUND_PAGE = 'RESET_EDUCATION_BACKGROUND_PAGE';
export const RESET_EDUCATION_BACKGROUND_META = 'RESET_EDUCATION_BACKGROUND_META';

//	Review and Submission Page
export const GET_APPLICATION_BY_APPLICATION_ID_REQUEST = 'GET_APPLICATION_BY_APPLICATION_ID_REQUEST';
export const GET_APPLICATION_BY_APPLICATION_ID_ERROR = 'GET_APPLICATION_BY_APPLICATION_ID_ERROR';
export const GET_APPLICATION_BY_APPLICATION_ID_SUCCESS = 'GET_APPLICATION_BY_APPLICATION_ID_SUCCESS';

export const SUBMIT_APPLICATION_REQUEST = 'SUBMIT_APPLICATION_REQUEST';
export const SUBMIT_APPLICATION_ERROR = 'SUBMIT_APPLICATION_ERROR';
export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';

export const RESET_APPLICATION_PAGE = 'RESET_APPLICATION_PAGE';
export const RESET_APPLICATION_META = 'RESET_APPLICATION_META';


//Application Status Page
export const GET_APPLICATION_STATUS_REQUEST = 'GET_APPLICATION_STATUS_REQUEST';
export const GET_APPLICATION_STATUS_ERROR = 'GET_APPLICATION_STATUS_ERROR';
export const GET_APPLICATION_STATUS_SUCCESS = 'GET_APPLICATION_STATUS_SUCCESS';

export const SUBMIT_APPLICATION_STATUS_REQUEST = 'SUBMIT_APPLICATION_STATUS_REQUEST';
export const SUBMIT_APPLICATION_STATUS_ERROR = 'SUBMIT_APPLICATION_STATUS_ERROR';
export const SUBMIT_APPLICATION_STATUS_SUCCESS = 'SUBMIT_APPLICATION_STATUS_SUCCESS';

export const SUBMIT_APPLICATION_PASSPORT_REQUEST = 'SUBMIT_APPLICATION_PASSPORT_REQUEST';
export const SUBMIT_APPLICATION_PASSPORT_ERROR = 'SUBMIT_APPLICATION_PASSPORT_ERROR';
export const SUBMIT_APPLICATION_PASSPORT_SUCCESS = 'SUBMIT_APPLICATION_PASSPORT_SUCCESS';

export const SUBMIT_APPLICATION_ITINERARY_REQUEST = 'SUBMIT_APPLICATION_ITINERARY_REQUEST';
export const SUBMIT_APPLICATION_ITINERARY_ERROR = 'SUBMIT_APPLICATION_ITINERARY_ERROR';
export const SUBMIT_APPLICATION_ITINERARY_SUCCESS = 'SUBMIT_APPLICATION_ITINERARY_SUCCESS';

export const SUBMIT_APPLICATION_INSURANCE_REQUEST = 'SUBMIT_APPLICATION_INSURANCE_REQUEST';
export const SUBMIT_APPLICATION_INSURANCE_ERROR = 'SUBMIT_APPLICATION_INSURANCE_ERROR';
export const SUBMIT_APPLICATION_INSURANCE_SUCCESS = 'SUBMIT_APPLICATION_INSURANCE_SUCCESS';

export const RESET_APPLICATION_STATUS_PAGE = 'RESET_APPLICATION_STATUS_PAGE';
export const RESET_APPLICATION_STATUS_META = 'RESET_APPLICATION_STATUS_META';
